import { TownsquareSiteAri } from '@atlassian/ari';
import { PreloadedQuery } from 'react-relay';

import { RelayResourceConfig, createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type {
	ResourceStoreContext,
	RouterContext,
	RouterDataContext,
	RouteResource,
} from '@townsquare/router/routing-types';
import type { ResourceContext } from '@townsquare/router/types';

import GoalTqlExplainerAggQueryNode, {
	GoalTqlExplainerAggQuery,
} from '../components/__generated__/GoalTqlExplainerAggQuery.graphql';

export const getGoalTqlExplainerAggResourceQuery = (
	routerContext: RouterContext | RouterDataContext,
	resourceContext: ResourceStoreContext,
): RelayResourceConfig<GoalTqlExplainerAggQuery> => {
	const { workspace } = resourceContext as ResourceContext;
	const { tql, viewUuid } = routerContext.query;
	const cloudId = workspace?.cloudId;
	const containerId = cloudId ? TownsquareSiteAri.create({ siteId: cloudId }).toString() : null;
	const hasTqlOrViewUuid = (!!tql || !!viewUuid) && !!containerId;

	return {
		environment: getAggRelayEnvironment(),
		query: GoalTqlExplainerAggQueryNode,
		variables: {
			searchString: tql,
			directoryViewId: viewUuid,
			containerId: containerId ?? '',
			hasTqlOrViewUuid,
		},
		options: {
			fetchPolicy: 'store-and-network',
		},
	};
};

export const tqlExplainerGoalAggResource: RouteResource<
	PreloadedQuery<GoalTqlExplainerAggQuery, Record<string, unknown>>
> = createRelayResource<GoalTqlExplainerAggQuery>({
	getQuery: getGoalTqlExplainerAggResourceQuery,
});
